export default __webpack_public_path__ + "static/media/logo_wallex.2861df61.svg";